module.exports = __webpack_public_path__ + "img/icon.7dd057ec.png";